import { ageTypes, travelerInputs } from '../constants';
const {
  ADULT,
  CHILD,
  INFANT
} = ageTypes;
const {
  TRAVELER_FORM_SECTION_NAME
} = travelerInputs;
const cutAndTrimString = (str, maxLength) => {
  let allowedLength = maxLength;
  const trimmedString = str.trim();
  if (allowedLength > trimmedString.length) {
    allowedLength = trimmedString.length;
  }
  return trimmedString.slice(0, allowedLength).trim();
};
export const getFullName = (firstName, lastName, maxLength) => {
  const modifiedLastName = cutAndTrimString(lastName, maxLength - 2);
  let firstNameMaxLength = maxLength - modifiedLastName.length - 1;
  if (firstNameMaxLength > firstName.length) {
    firstNameMaxLength = firstName.length;
  }
  const modifiedFirstName = cutAndTrimString(firstName, firstNameMaxLength);
  return `${modifiedFirstName} ${modifiedLastName}`;
};
export const getInitials = (firstName, lastName) => {
  if (!firstName.trim() || !lastName.trim()) {
    return '';
  }
  return `${firstName.trim()[0]}${lastName.trim()[0]}`.toUpperCase();
};
export const getTravelerFormSectionName = (id, subSection) => `${TRAVELER_FORM_SECTION_NAME}-${id}${subSection ? `.${subSection}-${id}` : ''}`;
export const resolveLabelFromType = (type, adultLabel, childLabel, infantLabel) => {
  switch (type) {
    case ADULT:
      {
        return adultLabel;
      }
    case CHILD:
      {
        return childLabel;
      }
    case INFANT:
      {
        return infantLabel;
      }
    default:
      {
        return undefined;
      }
  }
};
export const travelerAgeIcons = {
  [CHILD]: 'child-traveler',
  [INFANT]: 'infant-traveler',
  [ADULT]: 'adult-traveler'
};
//# sourceMappingURL=traveler.js.map